const selectBoxObjectMapper = (options, value) => {
  if (options && value) {
    const label = options.filter(item => item.value === value)[0]?.label;
    return { label, value };
  }
  return null;
};

export default selectBoxObjectMapper;
